module.exports = __webpack_public_path__ + "img/ic_bottom_arrow.38777906.svg";